import React from "react";
import { PARENT_FORM_CATEGORY_SLUG, USER_ROLE } from "Constants/constant";
import { isFrontlineEmployeeUser, roleAccess } from "helpers/RolesPermission";
import { BLK_PORTAL_PREMISSION_KEYS_CHILDREN } from "store/constants";
import { MdEmail, MdOutlineNotStarted } from "react-icons/md";
import { Link } from "react-router-dom";

const ActionsForSubmitPtForms = (props) => {
  const {
    view,
    slug,
    item,
    particpantUuid,
    role = "",
    setIsShowMultipleEmail,
    setSelectedFormForEmail,
    checkboxes,
  } = props;

  const permissionForSpStandardUser = () => {
    if (roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager,USER_ROLE.Sp_Standard_User])) return true;
    switch (slug) {
      case PARENT_FORM_CATEGORY_SLUG.HIGH_CARE.SLUG:
      case PARENT_FORM_CATEGORY_SLUG.MEDICATION.SLUG:
      case PARENT_FORM_CATEGORY_SLUG.INJURY_MANAGEMENT.SLUG:
        return true;
      default:
        return false;
    }
  };

  if (view === "table_header" && permissionForSpStandardUser()) {
    return (
      <th scope='col' className='form-table-actions-col py-3.5'>
        Action
      </th>
    );
  } else if (view === "table_data" && permissionForSpStandardUser()) {
    return (
      <td className='form-table-actions-col whitespace-nowrap py-4'>
        <div className='form-admin-actions'>
          {role !== "sil" &&
            (roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager]) ||
              (isFrontlineEmployeeUser() &&
                roleAccess(
                  [],
                  "participant",
                  BLK_PORTAL_PREMISSION_KEYS_CHILDREN.PARTICIPANT.FORM.SEND_EMAIL
                ))) && (
              <div
                className={`${
                  checkboxes?.length === 0
                    ? "cursor-pointer"
                    : "cursor-not-allowed opacity-50"
                } icon-stopPlay-wrapper`}
                title="Send this form via email"
                onClick={() => {
                  if (checkboxes?.length === 0) {
                    setIsShowMultipleEmail(true);
                    setSelectedFormForEmail(item);
                  }
                }}
              >
                <MdEmail className='icon-size' />
              </div>
            )}

          <Link
            to={
              role === "sil"
                ? `/view-template/sil/${particpantUuid}/${slug}/${item.slug}`
                : `/view-template/${particpantUuid}/${slug}/${item.slug}`
            }
            title="View details of this form"
          >
            <div className='cursor-pointer icon-stopPlay-wrapper'>
              <MdOutlineNotStarted className='icon-size' />
            </div>
          </Link>
        </div>
      </td>
    );
  } else {
    return <></>;
  }
};

export default ActionsForSubmitPtForms;
